import React from "react";

export default function LoginFormImage() {
  return (
    <div className="log-in__img">
      <img className="log-in__image" src="images/log-in.png" />
    </div>
  );
}
